import codeRacer from "../project/icons/code-reacer-logo.png";
import travel from "../project/icons/travelguide-logo.svg";
import homerun from "../project/icons/logo-homerun.png";
import renewbe from "../project/icons/logo-renewbe.png";
import seriesonline from "../project/icons/Serieslogo.png";
import sfb from "../project/icons/sfb.png";
import detective from "../project/icons/detective.jpg";
import superkick from "../project/icons/logo-superkick.png";
import { projectType } from "@/types/ProjectType";

export const projectsData: projectType[] = [
  {
    logo: sfb,
    title: "Sustainable Form Builder",
    description: "sfb_desc",
    videoUrl:
      "https://res.cloudinary.com/dwz4buven/video/upload/v1733494751/sfb_kkohp2.mp4",
    demoUrl: "https://client-testing.sfb-app.com/workspace",
  },
  {
    logo: travel,
    title: "Travel Guide",
    description: "travel_desc",
    videoUrl:
      "https://res.cloudinary.com/dwz4buven/video/upload/v1698214506/travelguide_xfxigd.mp4",
    demoUrl: "https://travelguide1.netlify.app/",
    githubUrl: "https://github.com/MuhammadOsama169/travel_guide",
  },
  {
    logo: homerun,
    title: "Homerun E-commerce site",
    description: "home_desc",
    videoUrl:
      "https://res.cloudinary.com/dwz4buven/video/upload/v1698250579/home_ci9brp.mp4",
    demoUrl: "https://homerun-next.vercel.app/",
    githubUrl: "https://github.com/MuhammadOsama169/HomeRun",
  },
  {
    logo: detective,
    title: "Murder Mystery Game",
    description: "game_desc",
    videoUrl:
      "https://res.cloudinary.com/dwz4buven/video/upload/v1698251127/crime_rfyjho.mp4",
    demoUrl: "https://hackathon-pearl-theta.vercel.app/",
    githubUrl: "https://github.com/MuhammadOsama169/hackathon",
  },
  {
    logo: seriesonline,
    title: "Watch Insights",
    description: "series_desc",
    videoUrl:
      "https://res.cloudinary.com/dwz4buven/video/upload/v1738479520/Untitled_Project_jms36x.mp4",
    demoUrl: "https://watchinsights.netlify.app/",
    githubUrl: "https://github.com/MuhammadOsama169/movie-insights-dashboard",
  },
  {
    logo: codeRacer,
    title: "Code Racer ",
    description: "code_desc",
    videoUrl:
      "https://res.cloudinary.com/dwz4buven/video/upload/v1698214501/code_tlk5p8.mp4",
    demoUrl: "https://code-racer-eight.vercel.app/",
    githubUrl: "https://github.com/MuhammadOsama169/code-racer",
  },
  {
    logo: superkick,
    title: "SuperKick Branding",
    description: "superkick_desc",
    videoUrl:
      "https://res.cloudinary.com/dwz4buven/video/upload/v1698214503/superkick_siilnu.mp4",
    demoUrl: "https://superkickbranding.netlify.app/",
    githubUrl: "https://github.com/MuhammadOsama169/project-outlaw",
  },
  {
    logo: renewbe,
    title: "Renewbe",
    description: "renewbe_desc",
    videoUrl:
      "https://res.cloudinary.com/dwz4buven/video/upload/v1698214502/renewbe_xgnvu0.mp4",
    demoUrl: "https://renewbe.netlify.app/",
    githubUrl: "https://github.com/MuhammadOsama169/Renewbe",
  },
];
